import {styled} from '@linaria/react';
import React from 'react';
import {tabletAndUpLinaria} from '../../../constants/customMedia';
import {HorizontalList} from '../HorizontalList/HorizontalList';
import {LogoList, LogoListProps} from './LogoList';

interface HorizontalLogoListProps extends LogoListProps {
  className?: string;
  dataTestId: string;
}

export const HorizontalLogoList: React.FC<HorizontalLogoListProps> = ({
  className,
  dataTestId,
  ...props
}) => {
  return (
    <HorizontalList data-testid={dataTestId} className={className}>
      <StyledLogoList {...props} />
    </HorizontalList>
  );
};

const StyledLogoList = styled(LogoList)`
  ${tabletAndUpLinaria(`justify-content: space-around;`)};
`;
